const mutations = {};

/**
 * 유저 정보
 * @param {*} state
 * @param {Object} value
 */
mutations.SET_USERINFO = (state, value) => {
  state.userInfo.userInfo = value;
};
/**
 * 유저 정보 업데이트
 * @param {*} state
 * @param {String} value
 */
mutations.UPDATE_USERINFO = (state, value) => {
  state.userInfo.userInfo = { ...state.userInfo.userInfo, ...value };
};
/**
 * 유저 사업자 정보
 * @param {*} state
 * @param {String} value
 */
mutations.SET_REGISTERSELECT = (state, value) => {
  state.userInfo.registerSelect = value;
};
/**
 * 사업자 처리 내역​
 * @param {*} state
 * @param {Array} value
 */
mutations.SET_USERINFOHISTORY = (state, value) => {
  state.userInfo.userInfoHistory = value;
};

mutations.SET_HAS_OTP = (state, value) => {
  state.userInfo.hasOTP = value;
};

export default {
  ...mutations,
};
